import globals from '../../globals'

export default function isCurrentPageProductList() {
  return window.location.pathname === globals.routes?.productList
}
